<template>
	<div class="row inputs-containers">
		<AppList :items="editInvoiceInfoList" />
	</div>
</template>

<script>
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppList from "@/shared/components/AppList.vue";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useCounterStore, useUserStore} from "@/console-new/stores";
import {formatDateMMDDHHmm, formatDateTime, formatDateYYMMDD} from "@/shared/helpers/dates";
import AppButton from "@/shared/components/AppButton.vue";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		const notificationStore = useNotificationStore();
		const counterStore = useCounterStore();
		return {getString: languageStore.getString, showNotification: notificationStore.showNotification, userStore, formatDateMMDDHHmm, formatDateYYMMDD, formatDateTime, counterStore}
	},
	name: "InvoiceDataEditor",
	components: {AppButton, AppList, AppTextInput},
	emits: ['update-invoice'],
	data() {
		return {
			nextSixMonths: new Date(new Date().setDate(new Date().getDate() + 180)),
			toUpdate: false,
			purchaseOrder: null,
		}
	},
	props: {
		startingPurchaseOrder: {
			type: String,
			default: null,
		},
	},
	computed: {
		editInvoiceInfoList() {
			return [
				{
					title: this.getString('purchase_order'),
					placeholder: this.getString('purchase_order'),
					explain: this.getString('purchase_order_info'),
					value: this.purchaseOrder,
					textInput: true,
					callbackText: (v)=> {
						this.toUpdate = true;
						this.purchaseOrder = v
					},
				},
			]
		}
	},
	methods: {
		initInputs() {
			this.purchaseOrder = this.startingPurchaseOrder || null;
		},
		getData() {
			if(!this.toUpdate) {
				return null;
			}
			return {
				purchase_order: this.purchaseOrder,
			}
		},
	},
	created() {
		this.initInputs();
	}
}
</script>

<style scoped lang="scss">
.inputs-containers {
	display: flex;
	flex-direction: column;
	align-items: flex-end;

	.input-container {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		gap: 12px;
		justify-content: space-between;
		align-items: center;
		position: relative;
		padding: 8px 12px;

		.ml-auto {
			margin-left: auto;
		}

		&:after {
			content: "";
			position: absolute;
			top: 100%;
			left: 0;
			height: 1px;
			width: 100%;
			background-color: var(--color-alpha-3);
		}

		&:last-child {
			&:after {
				display: none;
			}
		}
	}
}
</style>